import {AbstractControl, FormControl, FormGroup, ValidationErrors, Validators} from '@angular/forms';
import {PSD_VALIDATORS} from '../psd-validator';
import {textControl} from '../text-control';

export type PsdForm = FormGroup<{
  newPsd: FormControl<string>;
  confirmPsd: FormControl<string>;
}>;

export function psdMatchValidator(newKey = 'newPsd', confirmKey = 'confirmPsd') {
  return (control: AbstractControl): ValidationErrors | null => {
    const newPsd = control.get(newKey)?.value;
    const confirmPsd = control.get(confirmKey)?.value;

    if (!newPsd || !confirmPsd) {
      return null;
    }

    return newPsd === confirmPsd ? null : {psdMismatch: true};
  };
}

export function createPsdForm(): PsdForm {
  return new FormGroup({
    newPsd: textControl(PSD_VALIDATORS),
    confirmPsd: textControl([Validators.required]),
  }, {validators: [psdMatchValidator()]});
}
